module.exports = __webpack_public_path__ + "static/about-three-747ccee154c32cffe506f77b617de7c1.jpg";